import { defineStore } from 'pinia'
import { ref } from 'vue';
import { useSetSafeStorage } from '~/composables/useSetSafeStorage.js'

export const usePaymentKeysStore = defineStore('paymentKeys', () => {
    const { $axios } = useNuxtApp();
    const { slug } = useRestaurantStore();
    const route = useRoute();
    const stripeAcconutId = ref(useSafeStorage('stripeAcconutId') || null);

    async function getRestaurantAccountId(slugParam) {
        const slugs = slug ? slug : (Array.isArray(route.params.slug)
            ? route.params.slug[0]
            : route.params.slug);
        if(!slugParam) {
            slugParam = slugs;
        }
        try {
            const response = await $axios.get(`restaurants/account-id/${slugParam}`);
            stripeAcconutId.value = response.data.account_id;
            useSetSafeStorage('stripeAcconutId', stripeAcconutId.value)
        } catch (error) {
            console.error("Error fetching stripe account id mode:", error);
        }
    }

    watch(stripeAcconutId, (newStripeAcconutId) => {
        useSetSafeStorage('stripeAcconutId', newStripeAcconutId)
    });

    return {
        stripeAcconutId,
        getRestaurantAccountId
    }
})